<template>
	<div
		v-if="shouldShowTutorialFocusLayer"
		class="tutorial-overlay"
		:class="{ 'tutorial-overlay--transparent': isTransparentLock }"
	/>
</template>

<script lang="ts" setup>
import useQuestStore from "@/store/useQuestStore";
import { storeToRefs } from "pinia";
import { computed, ref, watch } from "vue";

const {
	tutorialActive,
	isTutorialHighlightingUI,
	tutorialStep,
	activeNarrativeId,
} = storeToRefs(useQuestStore());

const isUiBasedTutorialStep = ref<boolean>(false);
const isTransparentLock = ref<boolean>(false);
const isNarrativeStoryPlaying = ref<boolean>(false);

// Based on the currently known numbers, when we trigger UI-based tutorial steps
const uiBasedTutorialSteps = [7];

const shouldShowTutorialFocusLayer = computed(
	(): boolean =>
		(tutorialActive.value && isUiBasedTutorialStep.value) ||
		isTutorialHighlightingUI.value,
);

watch(
	(): number => tutorialStep.value,
	(newStep: number): void => {
		if ([9].includes(newStep)) {
			isTransparentLock.value = true;
		} else {
			isTransparentLock.value = false;
		}
		isUiBasedTutorialStep.value = uiBasedTutorialSteps.includes(newStep);
	},
);

// Osetrenie narrativy
watch(
	(): number | null => activeNarrativeId.value,
	(): void => {
		if (activeNarrativeId.value !== null) {
			isNarrativeStoryPlaying.value = true;
		} else {
			isNarrativeStoryPlaying.value = false;
		}
	},
	{ immediate: true },
);
</script>

<style lang="scss" scoped>
.tutorial-overlay {
	position: absolute;
	// must be lower than TutorialStep
	z-index: 9998;
	inset: 0;
	background: rgba(0, 0, 0, 0.6);
	width: 100vw;
	height: 100vh;

	// transparent lock layer
	&--transparent {
		background: transparent;
	}
}
</style>
